import React from 'react';
import { Grid, TextField, makeStyles } from '@material-ui/core';
import helpers from 'app/utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

function Identification({ isInternalForm, values, isGuest }) {
    const classes = useStyles();
    if (isGuest) return <></>;
    const isPerson = (helpers.somenteAlfanumericos(values?.deCpfCnpj)?.length ?? 0) <= 11;
    return (
        <>
            <Grid item xs={12} sm={4}>
                <TextField
                    value={helpers.formatarDocumento(values.deCpfCnpj)}
                    label={isPerson ? 'CPF*' : 'CNPJ*'}
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={isInternalForm ? 4 : 8}>
                <TextField
                    label={isPerson ? 'Nome completo*' : 'Razão Social*'}
                    variant="filled"
                    margin="dense"
                    fullWidth
                    value={values.nmUsuario}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={2} className={classes.positionRelative}>
                <TextField
                    value={helpers.formatarCep(values.deCep)}
                    label="CEP*"
                    variant="filled"
                    margin="dense"
                    disabled
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={2}>
                <TextField
                    label="UF*"
                    variant="filled"
                    margin="dense"
                    fullWidth
                    value={values.municipio?.uf?.sgUf}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    label="Município*"
                    variant="filled"
                    margin="dense"
                    fullWidth
                    value={values.municipio?.nmMunicipio}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField label="Bairro*" variant="filled" margin="dense" fullWidth value={values.deBairro} disabled />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Endereço*"
                    variant="filled"
                    margin="dense"
                    fullWidth
                    value={values.deEndereco}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={2}>
                <TextField
                    label="Número"
                    variant="filled"
                    margin="dense"
                    fullWidth
                    value={values.deNumeroEndereco}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    label="Complemento"
                    variant="filled"
                    margin="dense"
                    fullWidth
                    value={values.deComplemento}
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={8}>
                <TextField label="E-mail*" variant="filled" margin="dense" fullWidth value={values.deEmail} disabled />
            </Grid>
            <Grid item xs={12} sm={4}>
                <TextField
                    label="Telefone*"
                    variant="filled"
                    margin="dense"
                    fullWidth
                    value={helpers.formatarTelefone(values.deTelefone)}
                    disabled
                />
            </Grid>
        </>
    );
}

export default Identification;
